import { useEffect, useState } from 'react'
import type { Swiper as SwiperType } from 'swiper'

export function useSwiperWidth(swiperRef: React.RefObject<SwiperType | null>) {
	const [swiperWidth, setSwiperWidth] = useState<number | string>('100%')

	useEffect(() => {
		const inst = swiperRef.current
		const el = inst?.el

		if (!inst || !el) return

		const updateSwiperWidth = (inst: SwiperType) => {
			const width = inst.width - inst.maxTranslate()
			setSwiperWidth(width)
		}

		updateSwiperWidth(inst)

		inst.on('resize', updateSwiperWidth)
		return () => inst.off('resize', updateSwiperWidth)
	}, [swiperRef])

	return swiperWidth
}
